import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.profileTxt}>
                <div dangerouslySetInnerHTML={{ __html: content.ifengXMDTxt }} />
            </div>
        );
    }
}

export default Content;
